import type { FC } from "react";
import React from "react";
import { ChipDownContainer } from "@similarweb/ui-components";
import type {
    ITrafficFilter } from "app/pages/industry-analysis/market-builder/tabs/industry/table/table-top/TrafficFilter";
import {
    TrafficFilter
} from "app/pages/industry-analysis/market-builder/tabs/industry/table/table-top/TrafficFilter";
import { i18nFilter } from "app/filters/i18nFilter";
import { INITIAL_TRAFFIC } from "app/pages/industry-analysis/market-builder/tabs/industry/table/constants";
import { getSelectedFiltersAmount } from "app/pages/industry-analysis/market-builder/tabs/industry/table/table-top/utils";

interface ITrafficFilterDropdown extends ITrafficFilter {
    width?: number;
}

const resolveSelectedText = (selectedFiltersAmount: number): string => {
    if (selectedFiltersAmount === 0) {return null;}
    const i18n = i18nFilter();
    const isPlural = selectedFiltersAmount > 1;
    const key = isPlural
        ? `industry.research.market.builder.by.industry.traffic.filter.selected.plural`
        : `industry.research.market.builder.by.industry.traffic.filter.selected.singular`;
    return i18n(key, { selectedFiltersAmount });
};

export const TrafficFilterDropdown: FC<ITrafficFilterDropdown> = (props) => {
    const { traffic, setTraffic, width = 320 } = props;
    const i18n = i18nFilter();
    const dropdownRef = React.useRef(undefined);
    const selectedFiltersAmount = getSelectedFiltersAmount(traffic);
    const selectedText = resolveSelectedText(selectedFiltersAmount);
    const closeChipDown = () => dropdownRef?.current?.closePopup();

    const setTrafficMiddleWare = (value) => {
        closeChipDown();
        setTraffic(value);
    };
    return (
        <ChipDownContainer
            closeOnItemClick={false}
            ref={dropdownRef}
            width={width}
            selectedText={selectedText}
            buttonText={i18n("industry.research.market.builder.by.industry.traffic.filter")}
            onCloseItem={() => setTraffic(INITIAL_TRAFFIC)}
            noResultsMessage={i18n("dropdown.no.results")}
        >
            {[
                <TrafficFilter
                    key="trafficFilter"
                    setTraffic={setTrafficMiddleWare}
                    traffic={traffic}
                />,
            ]}
        </ChipDownContainer>
    );
};
